<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="copMaterial.pkid > 0 ? '编辑':'新建'"
        width="1000px"
        top="5vh"
        @close="$reset('form')">
      <el-form ref="form" :model="copMaterial" :rules="ruleValidate" label-width="100px" height="60vh">
        <el-tabs value="tab1" type="border-card">
          <el-tab-pane name="tab1" label="基础信息">
            <el-row>
              <el-col :span="12">
                <el-form-item label="程序版本" prop="materialNo">
                  <el-input v-model.trim="copMaterial.materialNo"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="程序类型" prop="param1">
                  <el-input v-model="copMaterial.param1"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="轿厢板" prop="param2">
                  <el-input v-model="copMaterial.param2"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电梯云" prop="param3">
                  <el-input v-model="copMaterial.param3"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注" prop="note">
                  <el-input type="textarea" v-model="copMaterial.note"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
        保存
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "CopMaterialEdit",
    // components: {ProductControlBoxSelect},
    data() {
      return {
        dialogVisible: false,
        dataTypes: constant.toSelect(constant.dataType),
        valueTypes: constant.toSelect(constant.valueType),
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        copMaterial: {
          pkid: 0,
          materialType: 10,
          materialNo: "",
          materialName: "",
          param1: "",
          param2: "",
          param3: "",
          param4: "",
          param5: "",
          param6: "",
          param7: "",
          note: "",
        },
        ruleValidate: {
          param1: [{required: true, message: "不能为空", trigger: "blur"}],
          param2: [{required: true, message: "不能为空", trigger: "blur"}],
          param3: [{required: true, message: "不能为空", trigger: "blur"}],
        },
      };
    },
    methods: {
      open: function(row, isCopy) {
        if (isCopy === 1) {
          this.isCopy = 1;
        }
        this.copMaterial.pkid = row.pkid;
        if (row) {
          this.getData(row.pkid);
        }
        this.dialogVisible = true;
      },
      getData(id) {
        this.$http
            .get("basic", `copmaterials/${id}`)
            .then(resp => {
              if (resp.success) {
                this.copMaterial = resp.data;
              }
            });
      },
      handleSubmit() {
        let isAdd = 1;
        if (this.copMaterial.pkid) {
          isAdd = 0;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", `copmaterials/save/${isAdd}`, this.copMaterial)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.$message.error(resp.message);
                    this.submitLoading = false;
                  }

                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },


    },
  };
</script>

<style lang="scss" scoped>
</style>
